import React from 'react';

export default function FwGlobeIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='fas fa-globe-americas' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
